{
  "ACDStatusHotKeys_Success_Available": "L'agent \"{}\" est disponible",
  "ACDStatusHotKeys_Success_Unavailable": "L'agent \"{}\" n'est pas disponible",
  "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Impossible de rendre \"{}\" disponible.\nCet agent est peut-être déjà disponible ou déconnecté.",
  "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Impossible de rendre \"{}\" indisponible.\nCet agent est peut-être déjà indisponible ou déconnecté.",
  "NAME": "ACDStatusHotKeys"
}